import { render, staticRenderFns } from "./Myorder.vue?vue&type=template&id=33b87cf4&scoped=true&"
import script from "./Myorder.vue?vue&type=script&lang=js&"
export * from "./Myorder.vue?vue&type=script&lang=js&"
import style0 from "./Myorder.vue?vue&type=style&index=0&id=33b87cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b87cf4",
  null
  
)

export default component.exports